import React, {Component} from 'react'
import {Tabs, Radio, Checkbox, Row, Col} from 'antd'
import {withTranslation} from 'react-i18next'

class CronGenerator extends Component {
  createCheckbox = (key, col, minNum, maxNum) => {
    let colArray = []
    let rowArray = []
    let count = col
    let keyNum = minNum
    for (minNum; minNum <= maxNum; minNum++) {
      let checkbox = <Col style={{marginRight: '5px'}} key={key + keyNum}><Checkbox key={key + keyNum}
                                                                                    value={minNum}>{this.formatNum(minNum)}</Checkbox></Col>
      if (count > 0) {
        colArray.push(checkbox)
        count--
        if (minNum === maxNum) rowArray.push(<Row key={key + keyNum}>{colArray}</Row>)
      } else {
        rowArray.push(<Row key={key + keyNum}>{colArray}</Row>)
        colArray = []
        minNum--
        count = col
      }
      keyNum++
    }
    return <Row>{rowArray}</Row>
  }
  formatNum = (num) => {
    if (num < 10 && num > -1) {
      return '0' + num
    }
    return num
  }

  render() {
    const {TabPane} = Tabs
    const {handleRadioChange, handleCheckboxChange, radioValue, cronParams, t} = this.props
    const radioStyle = {
      display: 'block',
    }
    this.createCheckbox('second', 6, 0, 59)
    this.createCheckbox('minute', 6, 0, 59)
    this.createCheckbox('hour', 12, 0, 23)
    const dayCheckbox = this.createCheckbox('day', 6, 1, 31)
    const monthCheckbox = this.createCheckbox('month', 12, 1, 12)
    const weekCheckbox = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT']
    return (
      <Tabs type="card" tabPosition="left" className="apiTabs">
        <TabPane tab={t(`general.day`)} key="4">
          <Radio.Group onChange={e => handleRadioChange(e, 'day')} value={radioValue['day']}>
            <Radio style={radioStyle} value={1}>
              {t(`apiManagement.executedPerDaily`)}
            </Radio>
            <Radio style={radioStyle} value={2}>
              {t(`apiManagement.noAssign`)}
            </Radio>
            <Radio style={radioStyle} value="point">
              {t(`apiManagement.assign`)}
            </Radio>
            <Checkbox.Group style={{width: '100%'}} onChange={e => handleCheckboxChange(e, 'day')} value={cronParams.day}>
              {dayCheckbox}
            </Checkbox.Group>
          </Radio.Group>
        </TabPane>
        <TabPane tab={t(`general.month`)} key="5">
          <Radio.Group onChange={e => handleRadioChange(e, 'month')} value={radioValue['month']}>
            <Radio style={radioStyle} value={1}>
              {t(`apiManagement.executedPerMonthly`)}
            </Radio>
            <Radio style={radioStyle} value={2}>
              {t(`apiManagement.noAssign`)}
            </Radio>
            <Radio style={radioStyle} value="point">
              {t(`apiManagement.assign`)}
            </Radio>
            <Checkbox.Group style={{width: '100%'}} onChange={e => handleCheckboxChange(e, 'month')} value={cronParams.month}>
              {monthCheckbox}
            </Checkbox.Group>
          </Radio.Group>
        </TabPane>
        <TabPane tab={t(`general.week`)} key="6">
          <Radio.Group onChange={e => handleRadioChange(e, 'week')} value={radioValue['week']}>
            <Radio style={radioStyle} value={1}>
              {t(`apiManagement.executedPerWeekly`)}
            </Radio>
            <Radio style={radioStyle} value={2}>
              {t(`apiManagement.noAssign`)}
            </Radio>
            <Radio style={radioStyle} value="point">
              {t(`apiManagement.assign`)}
            </Radio>
            <Checkbox.Group style={{width: '100%'}} onChange={e => handleCheckboxChange(e, 'week')} value={cronParams.week}>
              <Row>
                {weekCheckbox.map((item) =>
                  <Col style={{marginRight: '5px'}} key={item}>
                    <Checkbox key={item} value={item}>{item}</Checkbox>
                  </Col>
                )}
              </Row>
            </Checkbox.Group>
          </Radio.Group>
        </TabPane>
      </Tabs>
    )
  }
}

export default withTranslation()(CronGenerator)
